import confirmDialog from "@evercam/shared/plugins/confirmDialog"
import { defineNuxtPlugin } from "#app"

export default defineNuxtPlugin(confirmDialog)
